// Layout for the could-help matching surface (bead hf-e5-availability-ccp.2).
//
// CSS-only, like every other feature stylesheet here.
//
// The one layout decision that carries meaning: candidates are a plain list with
// equal weight. No emphasis on the first, no size difference, no colour that could
// read as a ranking — matching is a yes-or-no property, so the people who qualify
// qualify equally, and the order is only about how fresh the record is.
export const matchingStylesheet = `
.matching__meaning { margin: 0 0 var(--space-12, 0.75rem); color: var(--color-ink-muted, #5b6862); }
.matching__list { display: grid; gap: var(--space-12, 0.75rem);
  list-style: none; margin: 0; padding: 0; }
.matching__candidate { display: grid; gap: var(--space-4, 0.25rem);
  padding: var(--space-12, 0.75rem);
  border: 1px solid var(--color-border, #d7ded9); border-radius: var(--radius-8, 0.5rem); }
.matching__name { margin: 0; font-weight: 600; }
.matching__recorded, .matching__provenance, .matching__not-ready {
  margin: 0; color: var(--color-ink-muted, #5b6862); }
.matching__asked { display: block; }
`;
